import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const counterState = [
  {
    end: 10000,
    prefix: '',
    suffix: ' +',
    text: 'Years Of Experience',
    icon: 'yearExp',
  },
  {
    end: 10000,
    prefix: '',
    suffix: ' +',
    text: 'Promise To Satisfaction',
    icon: 'promise',
  },
  {
    end: 10000,
    prefix: '',
    suffix: ' +',
    text: 'Happy Clients',
    icon: 'happyClient',
  },
  {
    end: 10000,
    prefix: '',
    suffix: ' +',
    text: 'Events done',
    icon: 'eventsDone',
  },
];

const CounterSection = () => {
  return (
    <div className='counterUpDiv DBlock h-auto bg-transparent relative'>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-2 md:gap-8 pt-4'>
        {counterState?.map((counter) => (
          <CountUp
            key={counter?.end}
            start={0}
            end={counter?.end}
            duration={2}
            separator=','
            redraw={true}
            prefix={counter?.prefix}
            suffix={counter?.suffix}>
            {({ countUpRef, start }) => (
              <VisibilitySensor onChange={start} delayedCall>
                <div className='flex items-center md:gap-4 gap-2 sm:gap-1'>
                  <img
                    className='sm:w-16 w-12'
                    src={`/assets/svgs/${counter?.icon}.svg`}
                    alt='image'
                  />
                  <div className='counterText '>
                    <span
                      className='text-black text-xl font-medium md:text-3xl sm:text-xl sm:font-semibold mb-1 block'
                      ref={countUpRef}
                    />
                    <p className='text-eventGray text-xs sm:text-sm md:text-base tracking-wider capitalize font-medium'>
                      {counter?.text}
                    </p>
                  </div>
                </div>
              </VisibilitySensor>
            )}
          </CountUp>
        ))}
      </div>
    </div>
  );
};

export default CounterSection;
